@if (totalRecords > 0) {
  <div class="pure-g m-t-16 footer">
    <!-- Results per page (page size dropdown) -->
    <div class="pure-u-md-4-24 pure-u-lg-4-24 pure-u-xl-4-24">
      <mc-select
        style="width: 160px"
        [value]="pageLimit"
        label="Results per page"
        labelposition="left"
        fit="small"
        (optionselected)="onPageLimitChange($event)">
        @for (pageCount of pageLimitOptions; track $index) {
          <mc-option [value]="pageCount">{{ pageCount }}</mc-option>
        }
      </mc-select>
    </div>

    <!-- Pagination control -->
    <div class="pure-u-md-12-24 pure-u-lg-16-24 pure-u-xl-16-24 flex-container flex-center">
      <mc-pagination
        hiddenlabels
        [currentpage]="currentPage"
        [totalpages]="lastPage ?? 1"
        visiblepages="7"
        fit="small"
        [disabled]="isPaginationDisabled"
        (pagechange)="onPageChangeEvent($event)"></mc-pagination>
    </div>

    <!-- Showing info -->
    <div class="pure-u-md-6-24 pure-u-lg-4-24 pure-u-xl-4-24 text-align-right">
      <span class="page-description">
        {{ showingRange }}
      </span>
    </div>
  </div>
}
